<template>
  <img
    class="cm-documentation__content-image"
    :src="`/user_documentation/pictures/${data.content.src}`"
    :alt="data.content.alt"
  />
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style lang="scss">
.cm-documentation__content-image {
  max-width: 100%;
  box-shadow: 5px 7px 25px #56ac00;
  margin: 20px auto;
}
</style>
